import { Navigate, useLocation } from 'react-router-dom';
export const SingInGuard = ({ children }: { children: JSX.Element }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const oobCode = params.get('oobCode') as string;
  return oobCode ? children : <Navigate to="/login" />;
};
